import { combineReducers } from "redux";

import intentManagementReducer from "app/pages/sales-intelligence/sub-modules/intent/store/management/reducers/reducer";
import intentReducer from "app/pages/sales-intelligence/sub-modules/intent/store/signal/reducers/reducer";
import type { IntentManagementState, IntentState } from "app/pages/sales-intelligence/sub-modules/intent/types/common";
import type { WalkThroughState } from "app/pages/sales-intelligence/sub-modules/onboarding/types/WalkThroughType";
import walkThroughReducer from "app/pages/sales-intelligence/sub-modules/onboarding/walk-through/store/reducers/reducer";
import type { CommonState } from "app/pages/workspace/sales/sub-modules/common/store/reducer";
import commonReducer from "app/pages/workspace/sales/sub-modules/common/store/reducer";

import type { FeedState } from "../sub-modules/feed/store/reducer";
import feedReducer from "../sub-modules/feed/store/reducer";
import type { OpportunitiesState } from "../sub-modules/opportunities-lists/store/reducer";
import opportunitiesReducer from "../sub-modules/opportunities-lists/store/reducer";
import type { SignalsState } from "../sub-modules/signals/store/reducer";
import signalsReducer from "../sub-modules/signals/store/reducer";

export type SalesWorkspaceState = {
    feed: FeedState;
    signals: SignalsState;
    intentManagement: IntentManagementState;
    intent: IntentState;
    opportunities: OpportunitiesState;
    common: CommonState;
    walkThrough: WalkThroughState;
};

export default combineReducers<SalesWorkspaceState>({
    feed: feedReducer,
    signals: signalsReducer,
    intentManagement: intentManagementReducer,
    intent: intentReducer,
    opportunities: opportunitiesReducer,
    common: commonReducer,
    walkThrough: walkThroughReducer,
});
